import React, { createContext, useContext, useState, useEffect, ReactNode, useMemo } from 'react';
import { BusinessInfo } from 'types/business';

type KarunaContextType = {
  updateProductDetails: (cart: any, business: BusinessInfo, defaultVariant: any) => void;
  updateCartDetails: (cart: any) => void;
  updateOrderDetails: (order: any) => void;
};

const KarunaContext = createContext<KarunaContextType | undefined>(undefined);

export const KarunaProvider = ({ children }: { children: ReactNode }) => {
  const [gcmData, setGcmData] = useState({});

  useEffect(() => {
    window._gcm = gcmData;
  }, [gcmData]);

  const updateProductDetails = (cart: any, business: BusinessInfo, defaultVariant: any) => {
    setGcmData(() => ({
      business: {
        name: business?.name ?? '',
        categories: business?.categories ?? '',
        parent_category: business?.parent_category ?? '',
        photos: business?.photos ?? [],
        image: business?.photos?.length > 0 ? business?.photos[0] : '',
      },
      default_gift_card_value: defaultVariant?.price ?? 0,
      processing_fee: defaultVariant?.fee ?? 0,
      cart,
    }));
  };

  const updateCartDetails = (cart: any) => {
    setGcmData(() => ({
      cart: {
        items: cart.items,
        total: cart.total,
      },
    }));
  };

  const updateOrderDetails = (order: any) => {
    setGcmData(() => ({
      order: order,
      items: order?.items,
    }));
  };

  const contextValue = useMemo<KarunaContextType>(() => {
    return {
      updateProductDetails, updateCartDetails, updateOrderDetails,
    };
  }, [
    updateProductDetails, updateCartDetails, updateOrderDetails,
  ]);

  return (
    <KarunaContext.Provider value={contextValue}>
      {children}
    </KarunaContext.Provider>
  );
};

export const useKarunaContext = () => {
  const context = useContext(KarunaContext);
  if (!context) {
    throw new Error('useKaruna must be used within a KarunaProvider');
  }
  return context;
};